export const DEFAULT_TITLE_COLOR = "#2f5d46";

export const TITLE_COLOR_PRESETS = [
  { label: "Default", value: DEFAULT_TITLE_COLOR },
  { label: "Navy", value: "#284b8f" },
  { label: "Green", value: "#2f5d46" },
  { label: "Gold", value: "#c89a42" },
  { label: "Brick", value: "#9f4a3d" },
  { label: "Plum", value: "#6c4a7f" },
  { label: "Slate", value: "#4f6478" },
];
